import { Component, OnInit, Input, Output, OnChanges, EventEmitter, ViewChild, ElementRef, Inject, SimpleChanges, SimpleChange } from '@angular/core';
import PouchDB from 'pouchdb';
import PouchdbFind from 'pouchdb-find';
import { ShelfPouchDb } from '../shelf.pouchdb.service';
import { trigger, state, animate, transition, style } from '@angular/animations';
import * as _ from 'lodash';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Constants } from '../../shared/models/constants';
import { ShelfValues, bookCategories, bookCategoeyEnums } from '../../shared/models/shelfEnums';
import { Shelf } from '../../shared/models/shelf';
import { Book } from '../../shared/models/book';
import { GoogleService } from '../../shared/Google.service';
import { MatSnackBar } from '@angular/material';
import { PouchdbService } from '../../shared/pouchDb.service';
import { LoginObservableService } from "../../shared/loginObservable.service";
import { BookTemplate } from '../../shared/models/bookTemplate';
import { IS_ElectronService } from '../../shared/IS_Electron.service';
import { Component_interactionService } from '../../component_interaction.service';
import { LoginComponent } from '../popups/login/login.component';
import {
  AuthService,
  FacebookLoginProvider,
  GoogleLoginProvider
} from '../../../assets/angular5-social-login';

// import { TemplateAsEnrichmentComponent } from '../../bookShared/enrichmentTabs/template-as-enrichment/template-as-enrichment.component';

@Component({
  selector: 'app-mycontent',
  templateUrl: './mycontent.component.html',
  styleUrls: ['./mycontent.component.css', '../shelf.component.css'],
  animations: [
    trigger('show', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate(300, style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate(300, style({ opacity: 0 }))
      ])
    ]),
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),
      state('rotated', style({ transform: 'rotate(45deg)' })),
      transition('rotated => default', animate('300ms ease-out')),
      transition('default => rotated', animate('300ms ease-in'))
    ]),
  ],
})
export class MycontentComponent implements OnChanges {
  public title;
  public selectedTabList = 0;
  public myContentElements = [];
  public localDB;
  public remoteDB;
  public currentSelectedList;
  public shelfBooksArray = [];
  public allShelfElements = [];
  public allRecentFiles = [];
  public currentSelectedShelfIndex;
  rotateState: string = 'default';
  isShowAddNewFolder = false;
  public isNewItemsShow = false;
  public isCreateNewtemplate = false;
  tooltipposition = 'after';
  folderReName = '';
  bookTemplates: any;
  creatingEleData;
  currentAddingEle;
  GfolderCreatingState;
  currentDriveFolderId;
  displayShelfChildsFor;
  allShelfs;
  createFolderState = "folder";
  cteatedMytemplates = [];
  selectedMyContentCategoryInd = 0;
  lastSelectedInd = 0;
  folderAlreadyExist;
  allBooksBackup;
  subscription;
  shelfDataSubscription;
  userAppFeatures;
  isAlreadyInSameComponent = false;
  exportData: any;
  exportNotificationShow = false;
  avoidingFastSwitching = true;
  constructor(public dialog: MatDialog, private ele: ElementRef, public mainpouchservice: PouchdbService, public pouchservice: ShelfPouchDb, public GoogleService: GoogleService, public snackBar: MatSnackBar, private LoginObservableService: LoginObservableService, private ElectronService: IS_ElectronService, private Component_interactionService: Component_interactionService, private socialAuthService: AuthService) {

  }



  @ViewChild('myContentTab', { read: ElementRef }) public myContentTab: ElementRef;
  public addNewFolderArr = [{ 'name': 'Create Sub Shelf', 'icon': 'icon-Create-Folder', 'codeKey': 'Create_Shelf' }, { 'name': 'Create Shelf', 'icon': 'icon-Create-Folder', 'codeKey': 'Create_Shelf' }, { 'name': 'Create Book', 'icon': 'icon-EBE', 'codeKey': 'Create_Book' }, { 'name': 'Create Elesson', 'icon': 'icon-ELE', 'codeKey': 'Create_Elesson' }]

  @Output() messageEvent = new EventEmitter<any>();
  @Input() isLoggedIn: any;

  ngOnInit() {

    document['mycompthis'] = this;

    this.localDB = this.pouchservice.localDB;
    this.remoteDB = this.pouchservice.remoteDB;

    var self = this;
    this.subscription = this.LoginObservableService.cast.subscribe(data => {

      if (data == 'true') { // After LogIn section
        this.pouchservice.isRecentsDocAvailable().then(function (res) {
          self.pouchservice.getShelfData(self, 0)
          self.pouchservice.isMythemesDocAvailable(self);
        })

      } else  //Logout Section  for create defaultPouchDB //before LogIn
      {
        if (localStorage.nasResponse) {
          return
        }
        this.mainpouchservice.addDefaultPouchDB().then(function (data) {
          self.pouchservice.isRecentsDocAvailable().then(function (res) {
            self.pouchservice.alternateGetShelfData(0)
            self.pouchservice.isMythemesDocAvailable(self);
          })
        })
      }
    })

    this.shelfDataSubscription = this.pouchservice.interaction.subscribe(data => {
      self.updateListOfShlefs(data);
    })


    // auto login

    if (localStorage.nasResponse) {

      if (localStorage.userLogginedAt != 'already loggedIn') {
        this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID).then(
          (userData) => {
          });
        this.gettingDriveData();
        if (this.ElectronService.IS_ELECTRON) {
          var data = JSON.parse(localStorage.nasResponse);
          this.ElectronService.createUserIdFolder(data.signIn.organizationId + '_' + data.signIn.user.id);
        }

      }

      let sessionExpire = this.isSessionExpired()
      if (sessionExpire) {

        let userData = JSON.parse(localStorage.userData);
        this.Component_interactionService.connectingToNAS_Server(userData).then(function (data) {
          self.Component_interactionService.connectingToLCS_Server(data, '').then(function (res) {
            self.mainpouchservice.connnectToPouchDB(res, 'firstuser');
          })
        })

      } else {
        this.mainpouchservice.connnectToPouchDB('', '');
      }
    }
    localStorage.userLogginedAt = 'already loggedIn'


    if (!this.isLoggedIn) {
      var tempShelfObj = ['Purchases', 'Creations', 'Favorites', 'Imports']
      for (var i = 0; i < tempShelfObj.length; i++) {
        var shelfObj = new Shelf();
        shelfObj.createdAt = Math.round(new Date().getTime() / 1000);
        shelfObj.owner = Constants.USER;
        shelfObj.title = tempShelfObj[i];
        shelfObj.shelfType = "Default";
        shelfObj.category = 0;
        shelfObj._id = Constants.USER + ".0" + Math.round(new Date().getTime() / 1000) + "." + 'temp';
        this.myContentElements.push(shelfObj);
      }
    }


    this.isReplicatedsubscription = this.mainpouchservice.isReplicated$.subscribe(shelfs => {

      self.updateListOfShlefs(shelfs);

      if (self.currentSelectedList == undefined || self.currentSelectedList.title == 'All') {
        self.showAllBookRecords()
      }



    })

  }
  exportDataLength: any;
  isReplicatedsubscription: any

  getExportData(data, length, info) {

    var obj = {

      'exportedObject': info,
      'inboxBidsObject': data
    }

    this.exportData = obj;
    this.exportNotificationShow = true;
    if (length < 2) this.exportDataLength = length;
  }


  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.shelfDataSubscription) {
      this.shelfDataSubscription.unsubscribe();
    }
    if (this.isReplicatedsubscription) {
      this.isReplicatedsubscription.unsubscribe();
    }
    this.subscription = undefined;
    this.shelfDataSubscription = undefined;
    this.isReplicatedsubscription = undefined;
  }


  isSessionExpired() {

    let currentDate = new Date();
    let expDate = localStorage.sessionExpiresOn;
    expDate = new Date(expDate);

    let lastOpenedOn = localStorage.lastAppOpenedOn;
    lastOpenedOn = new Date(lastOpenedOn)

    let isWeekAgo = new Date(lastOpenedOn);
    let numberOfDaysToAdd = 7;
    isWeekAgo.setDate(isWeekAgo.getDate() + numberOfDaysToAdd);

    if (isWeekAgo > lastOpenedOn && currentDate < expDate) {
      return false;
    } else {
      return true;
    }

  }

  gettingDriveData() {
    var self = this;
    if (gapi && gapi.load && gapi.client) {
      gapi.load('client', {
        callback: function () {
        },
        onerror: function () {
        },
        timeout: 5000, // 5 seconds.
        ontimeout: function () {
        }
      });

      gapi.client.load('drive', 'v2', function () { });
    } else {
      setTimeout(function () {
        self.gettingDriveData();
      }, 1000);
    }
  }


  ngOnChanges(changes: SimpleChanges) {
    this.isLoggedIn = changes.isLoggedIn.currentValue;
  }

  openDialog(optName, evt, code): void {
    let name = 'New Shelf';
    this.createFolderState = optName;
    var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable(code);
    if (isFeatureAvailable == 'false') {
      //  this.openSnackBar("This Feature is Not Enabled", '');
      this.LoginObservableService.openSubscribenowPopup();
      return;
    }
    if (optName == 'Create Elesson') {
      this.newElePopup(evt);
      return;
    }

    let information = { 'name': name, data: this.myContentElements, state: 'creatingFolder' }
    let widthVal = '315px';
    if (optName == 'Create Book') {
      information.state = 'CreatingEBE';
      widthVal = '500px';
    }
    let dialogRef = this.dialog.open(NewFolderDialog, {
      width: widthVal,
      data: information,
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        if (result.state != 'createWebEBE' && result.state != 'createAlbum' && result.state != 'myTemplate') {
          this.addingNewFolder(result.name);
        }
        else if (result.state == 'createWebEBE') {
          this.addBookIntoCreations(result);
        }
        else if (result.state == 'myTemplate') {
          this.createMytemplateBook(result);
        }
        else {
          this.createNewAlbum(result);
        }
      }
    });
  }

  onItemDrop(ev, droppedAt, ind, state) {
    var self = this;
    if (ev.dragData.draggingFrom) {
      if (droppedAt.shelfType == "created" && (ev.dragData.draggingFrom == 'Purchases' || ev.dragData.draggingFrom == 'Creations' || ev.dragData.draggingFrom == 'Imports' || ev.dragData.draggingFrom == 'Favourites')) {

        if (ev.dragData.book.reference != '') {
          this.pouchservice.deletePrevReferenceBook(ev.dragData.book._id, ev.dragData.book.reference).then(function (res) {
            ev.dragData.book.reference = droppedAt._id;
            self.pouchservice.updateShelfData(droppedAt, ev.dragData.book, state);
          })
        }
        else {
          ev.dragData.book.reference = droppedAt._id;
          this.pouchservice.updateShelfData(droppedAt, ev.dragData.book, state);
        }


      }
      else if (droppedAt.shelfType != "created") {
        return;
      }
      else {

        if (ev.dragData.book.reference == droppedAt._id) {
          return;
        }


        let ind = self.getIndForGettingShelfData();

        if (ev.dragData.book.reference != '') {
          this.pouchservice.deletePrevReferenceBook(ev.dragData.book._id, ev.dragData.book.reference).then(function (res) {
            ev.dragData.book.reference = droppedAt._id;
            self.pouchservice.updateBookInfo(ev.dragData.book, false);
            self.pouchservice.moveBookToAnotherShelf(droppedAt, ev.dragData).then(function (res) {
              self.pouchservice.alternateGetShelfData(ind);

            })
          })
        }
        else {
          this.pouchservice.moveBookToAnotherShelf(droppedAt, ev.dragData).then(function (res) {
            // self.pouchservice.getShelfData(this,ind);
            self.pouchservice.alternateGetShelfData(ind);
          })
        }


      }
    }
    else {

      var isEqual = _.isEqual(ev.dragData, droppedAt);

      if (droppedAt.shelfType != "created" || isEqual || (ev.dragData._id == droppedAt.parentId)) {
        return;
      } else {
        this.pouchservice.dropShelfOnAnotherShelf(ev.dragData, droppedAt).then(function (data) {
          let selectInd = self.selectingShelfEleIndex(droppedAt._id)
        })
      }
    }
  }

  selectingShelfEleIndex(id) {
    var self = this;
    this.pouchservice.updateMyContentElements().then(function (data: any) {
      data = _.filter(data, function (filter) { return filter.parentId == undefined || filter.parentId == "" })
      self.myContentElements = data;
      var ind = _.findIndex(data, function (o: any) { return o._id == id });
      if (ind != -1) {
        self.pouchservice.alternateGetShelfData(ind);
      } else {
        self.pouchservice.alternateGetShelfData(0);
      }
    })
  }

  createMytemplateBook(result) {
    var self = this;
    if (!result.templateId) {
      var theme = new BookTemplate();
      if (result.theme.cover.contentDocId.length > 0) {
        theme.cover.type = 1;
        theme.cover.thumbUrl = result.theme.cover.thumbUrl;
        theme.cover.contentDocId = result.theme.cover.contentDocId
      }
      else {
        theme.cover.thumbUrl = result.theme.cover.thumbUrl;
      }

      if (result.theme.page.contentDocId.length > 0) {
        theme.page.type = 1;
        theme.page.thumbUrl = result.theme.page.thumbUrl;
        theme.page.contentDocId = result.theme.page.contentDocId;
      }
      else {
        theme.page.thumbUrl = result.theme.page.thumbUrl;
      }

      if (result.theme.back.contentDocId.length > 0) {
        theme.back.type = 1;
        theme.back.thumbUrl = result.theme.back.thumbUrl;
        theme.back.contentDocId = result.theme.back.contentDocId;
      }
      else {
        theme.back.thumbUrl = result.theme.back.thumbUrl;
      }

      theme._id = Constants.USER + ".bookTemplate";
      theme.templateId = '' + Math.round(new Date().getTime() / 1000)
      this.pouchservice.addMyTemplateDoc(theme, result.bookName).then(function (res: any) {
        self.addingCreatingTemplateBook(res._id, res.name);
      })
    }
    else {
      this.addingCreatingTemplateBook(result.templateId, result.bookName);
    }
  }

  addingCreatingTemplateBook(id, name) {

    var bookObj = new Book();
    bookObj.author = Constants.USER;
    bookObj.bookType = bookCategoeyEnums.Ebook;
    bookObj.bookCategory = ShelfValues.Creations;
    bookObj.title = name;
    bookObj.owner = Constants.USER;
    bookObj.bId = Constants.getGUID();
    bookObj._id = Constants.USER + "." + Math.round(new Date().getTime() / 1000) + ".book";
    bookObj.coverPage = '';
    bookObj.isCustomTemplate = true;
    bookObj.templateId = id;
    let findSelectedInd = this.getIndForGettingShelfData();
    this.pouchservice.addBookIntoShelf(findSelectedInd, this.currentSelectedList, bookObj);

  }

  isDraggable(data) {
    if (data.shelfType != 'created' ) {
      return false;
    } else {
      return true;
    }
  }

  addingNewFolder(name) {

    var self = this;
    var timestamp = Math.round(new Date().getTime() / 1000);
    var id = Constants.USER + "." + timestamp + ".shelf"

    var category;
    if (name == 'Purchases') {
      category = ShelfValues.Purchases
    }

    else if (name == 'Creations') {
      category = ShelfValues.Creations
    }
    else if (name == 'Imports') {
      category = ShelfValues.Imports
    }
    else {
      category = '';
    }

    var shelfObj = new Shelf();
    shelfObj.bookIds = [];
    shelfObj.createdAt = timestamp;
    shelfObj.owner = Constants.USER;
    shelfObj.title = name;
    shelfObj.shelfType = "created";
    shelfObj.category = category;
    shelfObj._id = id;
    this.GfolderCreatingState = 'shelf';
    var ind = this.getIndForGettingShelfData();
    if (this.currentSelectedList != undefined && this.currentSelectedList.shelfType == "created" && this.createFolderState == "Create Sub Shelf") {
      shelfObj.parentId = this.currentSelectedList._id;
      this.pouchservice.createSubShelf(shelfObj).then(function (res) {
        self.pouchservice.alternateGetShelfData(ind)
      })
    } else {
      this.pouchservice.createShelf(shelfObj).then(function (res) {
        self.pouchservice.alternateGetShelfData(ind);
      })
    }
  }

  addNewItem() {
    this.isNewItemsShow = !this.isNewItemsShow;
    this.isCreateNewtemplate = true;
  }
  receivedMessage(event) {
    this.messageEvent.emit(event);

  }

  showAllBookRecords() {
    var self = this;
    if (!this.avoidingFastSwitching) {
      return;
    } else {
      this.avoidingFastSwitching = false;
      setTimeout(function () {
        self.avoidingFastSwitching = true;
      }, 0);
    }

    let isAlreadyInAllComponent = false;
    this.isAlreadyInSameComponent = false;
    if (this.currentSelectedList && this.currentSelectedList.title == 'All') {
      isAlreadyInAllComponent = true;
    } else {
      this.Component_interactionService.updateBooksData([]);
    }

    this.currentSelectedShelfIndex = 'all';

    if (this.currentSelectedList) {
      this.currentSelectedList.isSelected = false;
    }


    this.currentSelectedList = JSON.parse(JSON.stringify(this.myContentElements[0]));
    this.currentSelectedList.title = "All"
    this.selectedTabList = undefined;
    this.pouchservice.formAllShelfsArray();

    this.ele.nativeElement.querySelectorAll('.allItemsCls')[0].classList.add('selectedListClass');
    this.ele.nativeElement.querySelectorAll('.commonIconClass')[0].classList.add('selectedListClass');
    var self = this
    this.pouchservice.getRecentData(this).then(function (res: any) {

      self.allRecentFiles = res;
      self.allBooksBackup = JSON.parse(JSON.stringify(self.allShelfElements));
      self.allShelfElements = _.uniqBy(self.allShelfElements, '_id')

      self.mappingAllShelfElements()

      var obj = {
        'name': 'AllComponent',
        'data': self.allShelfElements,
        'type': 'All',
        'recentData': self.allRecentFiles
      }

      if (isAlreadyInAllComponent) {
        self.Component_interactionService.updateBooksData(obj);
      }
      else {
        self.messageEvent.emit(obj);
      }



    })
    if (this.isNewItemsShow) {
      this.isNewItemsShow = false;
      this.rotate();
    }
  }

  loadFirstComp() {

    this.messageEvent.emit({ 'name': 'PurchasesComponent' });
    this.navigatePage(0, this.myContentElements[0]);
  }

  mappingAllShelfElements() {
    let compThis = parent.window.document['mycompthis'];
    // compThis.myContentElements
    for (var i = 0; i < this.allShelfElements.length; i++) {

      var id = this.allShelfElements[i]._id;
      var shelf = _.filter(compThis.myContentElements, function (filter) { return filter._id == id });
      var order = shelf[0].bookIds;
      var a = []
      for (var n = 0; n < order.length; n++) {
        var book = _.filter(this.allShelfElements[i].data, function (filter) { return filter._id == order[n] });
        if (book[0]) {
          a.push(book[0])
        }
      }
      this.allShelfElements[i].data = a;
    }
  }


  navigatePage(index, list) {
    var self = this;

    if (!this.avoidingFastSwitching) {
      return;
    } else {
      this.avoidingFastSwitching = false;
      setTimeout(function () {
        self.avoidingFastSwitching = true;
      }, 0);
    }

    this.currentSelectedShelfIndex = '';
    if (list._id == this.currentSelectedList._id && this.currentSelectedList.title != 'All') {
      this.isAlreadyInSameComponent = true;
    } else {
      this.isAlreadyInSameComponent = false;
      this.Component_interactionService.updateBooksData([]);
    }


    if (this.isNewItemsShow) {
      this.isNewItemsShow = false;
      this.rotate();
    }
    // if (!this.isLoggedIn) {
    //   this.openSnackBar('please login', '');
    //   return;
    // }


    // this.myContentTab.nativeElement.querySelectorAll('.allItemsCls').classList.remove('selectedListClass');
    if (this.currentSelectedList) {
      this.currentSelectedList.isSelected = false;
    }
    list.isSelected = true;
    this.ele.nativeElement.querySelectorAll('.allItemsCls')[0].classList.remove('selectedListClass');
    this.ele.nativeElement.querySelectorAll('.commonIconClass')[0].classList.remove('selectedListClass');
    this.selectedTabList = index;
    this.currentSelectedList = list;
    this.pouchservice.getBookData(list).then(function (res: any) {
      self.shelfBooksArray = res;
      self.updateBooksInShelf();
    })

  }
  updateBooksInShelf() {

    var obj = {
      'name': 'PurchasesComponent',
      'data': this.shelfBooksArray,
      'type': this.currentSelectedList.title,
      'shelf': this.currentSelectedList
    }

    if (this.isAlreadyInSameComponent) {
      this.Component_interactionService.updateBooksData(obj);
    } else {
      this.messageEvent.emit(obj);
    }


  }

  rotate() {
    this.rotateState = (this.rotateState == 'default' ? 'rotated' : 'default');
    if (this.isShowAddNewFolder) {
      this.isShowAddNewFolder = false;
    }
  }

  createNewBookOptions() {

    // if (this.isLoggedIn) {
    this.isNewItemsShow = !this.isNewItemsShow;
    this.rotate();
    // }
    //  else {
    //   this.isNewItemsShow = false;
    //   this.openSnackBar('please login', '');
    // }
  }


  updateHover(state, obj, arrayList) {
    if (state == 'enter') {
      this.removeHoverId(arrayList);
      obj.isHovered = true;
    }
    else {
      this.removeHoverId(arrayList);
    }
  }

  removeHoverId(arrayList) {
    for (var i = 0; i < arrayList.length; i++) {
      arrayList[i].isHovered = false;
      if (arrayList[i].subFolder) {
        this.removeHoverId(arrayList[i].subFolder);
      }
    }
  }

  editFolderName(ev, data, folderArray, ind) {
    var self = this;
    // ev.stopPropagation();
    this.clearIsFolderEdit(folderArray);
    this.folderReName = data.title;
    data.isEdit = true;
    let parentElement = ev.currentTarget.closest('.listOfElements');
    setTimeout(function () {
      let inputElement = parentElement.querySelector('input')
      inputElement.focus();
    }, 200);

  }

  updateFolderNewName(ev, data, folderArray, name) {

    if (name == '') {
      name = data.title;
    }
    else {
      this.folderAlreadyExist = undefined;
      this.isFolderNameAlreadyExist(this.myContentElements, name);
      if (this.folderAlreadyExist != undefined) {
        this.openSnackBar("Folder Name Already Exist", '');
        name = data.title;
      } else {
        this.navigatePage(this.selectedTabList, this.currentSelectedList);
      }
    }

    ev.stopPropagation();
    data.title = name;
    this.pouchservice.updateShelfObject(data);
    this.clearIsFolderEdit(folderArray);
  }


  isFolderNameAlreadyExist(data, name) {
    if (name == 'Purchases' || name == 'Creations' || name == 'Imports' || name == 'Favourites' || name == 'Favourites') {
      this.folderAlreadyExist = true;
    }
  }


  clearIsFolderEdit(folderArray) {
    for (var i = 0; i < folderArray.length; i++) {
      folderArray[i].isEdit = false;
      if (folderArray[i].subFolder) {
        this.removeHoverId(folderArray[i].subFolder);
      }
    }
  }

  onEnterChangeFolderName(ev, data, folderArray, name) {
    ev.stopPropagation();
    if (ev.which == '13') {
      this.updateFolderNewName(ev, data, folderArray, name);
    }
  }

  deleteFolder(obj, array, ind, ev) {
    ev.stopPropagation();
    let information = {
      folder: obj,
      array: array,
      index: ind
    }
    let dialogRef = this.dialog.open(deleteFolderPopup, {
      width: '315',
      data: information,
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.pouchservice.deleteShelf(obj)
      }
    });
  }

  addBookIntoCreations(result) {
    let name = result.bookName;
    let theme = result.theme;

    var bookObj = new Book();

    bookObj.author = Constants.USER;
    bookObj.bookType = result.type == "book" ? bookCategoeyEnums.Ebook : bookCategoeyEnums.Album;
    bookObj.templateId = theme.ID;
    bookObj.bookCategory = ShelfValues.Creations;
    bookObj.title = name;
    bookObj.owner = Constants.USER;
    bookObj.bId = Constants.getGUID();
    bookObj._id = Constants.USER + "." + Math.round(new Date().getTime() / 1000) + ".book";

    this.GfolderCreatingState = 'EBE';
    let findSelectedInd = this.getIndForGettingShelfData();
    this.pouchservice.addBookIntoShelf(findSelectedInd, this.currentSelectedList, bookObj);
  }
  newElePopup(ev) {
    let dialogRef = this.dialog.open(createEleComponent, {
      width: '400px',
      data: 'information',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.createNewElessonBook(result)
      }
    });
  }

  displayChildrenList(list) {
    var self = this;
    if (list.isChildrenShow) {
      list.isChildrenShow = false;
    } else {
      this.displayShelfChildsFor = list;
      this.pouchservice.getShelfChildren(list).then(function (res) {
        self.updateShelfChildren(res)
      })
    }
  }
  updateShelfChildren(childs) {
    this.displayShelfChildsFor.childrenArr = childs;
    this.displayShelfChildsFor.isChildrenShow = true;
  }

  imageAddedIntoDrive(file) {
    if (this.ElectronService.IS_ELECTRON) {
      this.currentAddingEle.coverPage = file;
    }
    else {
      this.currentAddingEle.coverPage = file.thumbnailLink;
    }

    this.currentAddingEle.gDriveId = localStorage.currentDriveMediaId;
    let findSelectedInd = this.getIndForGettingShelfData();
    this.pouchservice.addBookIntoShelf(findSelectedInd, this.currentSelectedList, this.currentAddingEle);
  }

  downloaddAndCreateNewElessonBook(bookObj, result) {
    this.addCreatedEleInShelf(bookObj, result)
  }

  createNewElessonBook(result) {

    var bookObj = new Book();
    bookObj.author = Constants.USER;
    bookObj.bookType = 3;
    bookObj.bookCategory = ShelfValues.Creations;
    bookObj.title = result.name;
    bookObj.owner = Constants.USER;
    bookObj.bId = Constants.getGUID();
    bookObj._id = Constants.USER + "." + bookObj.bId + ".book";
    bookObj.coverPage = result.imageUrl;

    this.addCreatedEleInShelf(bookObj, result)

  }


  addCreatedEleInShelf(bookObj, result) {
    this.currentAddingEle = bookObj;
    this.GfolderCreatingState = 'ELE';
    this.creatingEleData = result;
    if (this.ElectronService.IS_ELECTRON) {
      this.ElectronService.insertFileintoMediaFolder(result.imageDetails.target.files[0], this);
    }
    else {
      this.GoogleService.insertFileintofloder(result.imageDetails.target.files[0], result.imageDetails.target.files, localStorage.currentDriveMediaId, false, this);
    }


  }

  createNewAlbum(result) {
    var bookObj = new Book();
    bookObj.author = Constants.USER;
    bookObj.bookType = 8;
    bookObj.bookCategory = ShelfValues.Creations;
    bookObj.title = result.name;
    bookObj.owner = Constants.USER;
    bookObj.bId = Constants.getGUID();
    bookObj._id = Constants.USER + "." + Math.round(new Date().getTime() / 1000) + ".book";
    bookObj.coverPage = '';
    this.GfolderCreatingState = 'ALB';
    let findSelectedInd = this.getIndForGettingShelfData();
    this.pouchservice.addBookIntoShelf(findSelectedInd, this.currentSelectedList, bookObj);
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      panelClass: ['snack-bar-color'],
      duration: 2000,
    });
  }


  updateListOfShlefs(data) {


    this.myContentElements = _.filter(data, function (filter) { return filter.parentId == undefined || filter.parentId == "" })
    document.getElementsByClassName('showApploader')[0].classList.remove('hideApploader');
    this.allShelfs = this.myContentElements;

    if (this.currentSelectedList) {
      var name = this.currentSelectedList.title
      var ind = _.findIndex(this.myContentElements, function (o) { return o.title == name });
      if (ind != -1) {
        this.ele.nativeElement.querySelectorAll('.allItemsCls')[0].classList.remove('selectedListClass');
        this.ele.nativeElement.querySelectorAll('.commonIconClass')[0].classList.remove('selectedListClass');
        this.myContentElements[ind].isSelected = true;
        this.currentSelectedList = this.myContentElements[ind];
        this.navigatePage(ind, this.currentSelectedList);

      }
      else {
        this.currentSelectedList.isSelected = false;
        this.ele.nativeElement.querySelectorAll('.allItemsCls')[0].classList.add('selectedListClass');
        this.ele.nativeElement.querySelectorAll('.commonIconClass')[0].classList.add('selectedListClass');

      }
    }
  }


  selectedMyContentCategory(ev) {
    var self = this;

    if (!this.avoidingFastSwitching) {
      return;
    } else {
      this.avoidingFastSwitching = false;
      setTimeout(function () {
        self.avoidingFastSwitching = true;
      }, 500);
    }

    var temp;
    if (ev.index == 1) {
      temp = 'Inbox';
      // self.pouchservice.updateInboxData();

      // if (localStorage.allDocsReplicated == "true")
      self.Component_interactionService.updateInboxData(self.mainpouchservice.localDB, self.mainpouchservice.remoteDB, 0);

    } else if (ev.index == 2) {
      temp = 'Cloud';
    }

    if (temp) {
      var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable(temp);
      if (isFeatureAvailable == 'false') {
        this.LoginObservableService.openSubscribenowPopup();
        this.selectedMyContentCategoryInd = this.lastSelectedInd;
        return;
      }
    }

    this.selectedMyContentCategoryInd = ev.index;
    this.lastSelectedInd = ev.index;
    if (ev.index == 0) {
      // this.currentSelectedList = undefined;
      // this.showAllBookRecords();
      this.Component_interactionService.updateBooksData([]);
      this.pouchservice.updateMyContentElements().then(function (data) {
        self.updateListOfShlefs(data)
        self.pouchservice.formAllShelfsArray();
        self.switchToContent();
      })


    } else if (ev.index == 1) {
      this.exportNotificationShow = false;
    }
  }

  switchToContent() {
    var self = this;
    if (this.currentSelectedList) {
      this.currentSelectedList.isSelected = false;
    }

    this.currentSelectedList = JSON.parse(JSON.stringify(this.myContentElements[0]));
    this.currentSelectedList.title = "All";
    this.ele.nativeElement.querySelectorAll('.allItemsCls')[0].classList.add('selectedListClass');
    this.ele.nativeElement.querySelectorAll('.commonIconClass')[0].classList.add('selectedListClass');

    var obj = {
      'name': 'AllComponent',
      'data': self.allShelfElements,
      'type': 'All',
      'recentData': self.allRecentFiles
    }
    self.messageEvent.emit(obj);

  }


  disableMyContentTabs(tab) {
    var code;
    if (tab == 'Inbox') {
      code = 'Inbox'
    } else if (tab == 'Cloud') {
      code = 'Cloud'
    }

    if (localStorage.userData != undefined && localStorage.userData != 'undefined') {
      var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable('Shelf_Search');
      if (isFeatureAvailable == 'false') {
        return true;
      } else {
        return false;
      }
    } else {
      return false
    }


  }


  navigateToAllComponent() {
    var self = this;
    this.currentSelectedShelfIndex = 'all';

    if (this.currentSelectedList) {
      this.currentSelectedList.isSelected = false;
    }
    this.currentSelectedList = JSON.parse(JSON.stringify(this.myContentElements[0]));
    this.currentSelectedList.title = "All"
    this.selectedTabList = undefined;
    this.ele.nativeElement.querySelectorAll('.allItemsCls')[0].classList.add('selectedListClass');
    this.ele.nativeElement.querySelectorAll('.commonIconClass')[0].classList.add('selectedListClass');

    self.allShelfElements = _.uniqBy(self.allShelfElements, '_id')
    var obj = {
      'name': 'AllComponent',
      'data': self.allShelfElements,
      'type': 'All',
      'recentData': self.allRecentFiles
    }
    self.messageEvent.emit(obj);

  }

  displaySearchRecords(name) {
    var self = this;
    if (this.currentSelectedShelfIndex != 'all') {
      this.navigateToAllComponent();
      // self.showAllBookRecords()
    }

    if (name == '') {
      this.allShelfElements = [];
      this.allShelfElements = JSON.parse(JSON.stringify(this.allBooksBackup));
    }

    var tempAllBooks = JSON.parse(JSON.stringify(this.allBooksBackup))
    for (var i = 0; i < tempAllBooks.length; i++) {
      tempAllBooks[i].data = _.filter(self.allBooksBackup[i].data, function (filter) { return filter.title.includes(name) })
    }

    this.allShelfElements = tempAllBooks;
    var obj = {
      'name': 'AllComponent',
      'data': this.allShelfElements,
      'type': 'All',
      'recentData': this.allRecentFiles
    }
    self.Component_interactionService.updateBooksData(obj);
  }

  inboxCallBack(data) {

    var obj = {
      'name': 'InboxComponent',
      'data': data,
      'type': 'Inbox'

    }

    this.messageEvent.emit(obj);
    // alert('call from inbox')

  }

  ondraghover(data) {
    if (data.shelfType == 'Default') {
      return 'temp';
    } else {
      return 'onDraghoverClass'
    }
  }

  getIndForGettingShelfData() {
    var ind = this.selectedTabList
    if (ind == undefined) {
      ind = 0;
    }
    else {
      ind = ind + 1
    }
    return ind;
  }

}

// creating new ELE component
@Component({
  selector: 'app-createELE',
  templateUrl: './createELE.popup.html',
  styleUrls: ['../shelf.component.css', './mycontent.component.css']
})

export class createEleComponent {
  newEleTitle = '';
  imageDetails;
  eleErrMsg = false;
  constructor(
    public dialogRef: MatDialogRef<createEleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

  }
  selectedImage = undefined;
  @ViewChild('selectImg', { read: ElementRef }) public selectImg: ElementRef;
  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick() {
    this.newEleTitle = this.newEleTitle.trim();
    if (this.newEleTitle == '' || !this.imageDetails) {
      this.eleErrMsg = true;
      return;
    }
    this.eleErrMsg = false;
    let tempObj = {
      name: this.newEleTitle,
      imageUrl: this.url,
      imageDetails: this.imageDetails
    }
    this.dialogRef.close(tempObj);
  }

  selectImages(ev) {
    this.selectImg.nativeElement.click();
  }

  url;
  readURL(fileInput) {
    this.imageChangedEvent = fileInput;
    this.imageDetails = fileInput;
    if (fileInput.target.files && fileInput.target.files[0]) {
      const reader = new FileReader();

      reader.onload = ((e) => {
        this.url = e.target['result'];
      });
      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  addElessonOnEnter(ev) {
    if (ev.which == 13) {
      this.onYesClick();
    }
  }

  imageChangedEvent: any = '';
  croppedImage: any = '';

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(image: string) {
    this.croppedImage = image;
  }
  imageLoaded() {
    // show cropper
  }
  loadImageFailed() {
    // show message
  }

}
// creating ELE component End


// delete folder popup
@Component({
  selector: 'app-deletepopup',
  templateUrl: './deleteFolder.popup.html',
  styleUrls: ['../shelf.component.css', './mycontent.component.css']
})
export class deleteFolderPopup {

  constructor(
    public dialogRef: MatDialogRef<deleteFolderPopup>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(data) {
    this.dialogRef.close(data);
  }


}
// delete folder popup end







// creating new folder template

@Component({
  selector: 'app-popup',
  templateUrl: './newFolder.popup.html',
  styleUrls: ['../shelf.component.css', './mycontent.component.css']
})
export class NewFolderDialog {
  @ViewChild('selectEBEImg', { read: ElementRef }) public selectEBEImg: ElementRef;
  @ViewChild('myTemplateImgInput', { read: ElementRef }) public myTemplateImgInput: ElementRef;
  showError = false;
  newFolderTitle = '';
  isFolderNameEmpty = false;
  selectedThemeInd = undefined;
  bookNameErr = false;
  ebeBookTitle = '';
  selectedBookTypeInd: Number = 0;
  selectedTemplateViewInd = 0;
  bookTemplates;
  bookTemplateDetails;
  bookThemes;
  url;
  imageDetails;
  isAvailable;


  myTempCoverUrl = '';
  myTempPageUrl = '';
  myTempBackUrl = '';
  myTemplateImgState;
  MyTempBookTitle = '';
  myTemplateBookErr = false;
  myTemplatesList = [];
  showSelectingMyTemplate = false;
  selectedMyTemplateInd = undefined;
  mySelectedTemplateId = undefined;
  templateAsEnrichmentObj: any = {
    showPopup: false
  }
  myTempCoverContentDocId = '';
  myTempPageContentDocId = '';
  myTempBackContentDocId = '';

  myTemplateCoverSelectedType = 'Image';
  myTemplatePageSelectedType = 'Image';
  myTemplateBackSelectedType = 'Image';

  constructor(
    public dialogRef: MatDialogRef<NewFolderDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any, private GoogleService: GoogleService, public pouchservice: ShelfPouchDb, private ElectronService: IS_ElectronService, private LoginObservableService: LoginObservableService, public snackBar: MatSnackBar) {
    if (!this.ElectronService.IS_ELECTRON) {
      this.bookTemplates = Constants.getBookTemplatesArr();
      this.bookTemplateDetails = Constants.getTemplates();
    }
    else {
      this.bookTemplates = Constants.getElectronBookTemplatesArr();
      this.bookTemplateDetails = Constants.getElectronTemplates()
    }

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  isFolderNameAlreadyExist(data, name) {
    if (name == 'Purchases' || name == 'Creations' || name == 'Imports' || name == 'Favourites' || name == 'Favorites') {
      this.isAvailable = true;
    }
  }

  onYesClick(name) {
    name = name.trim();
    if (name == '') {
      this.isFolderNameEmpty = true;
      return;
    }
    this.isFolderNameEmpty = false;
    this.showError = false;
    this.isAvailable = undefined;
    this.isFolderNameAlreadyExist(this.data.data, name);



    // let isAvailable = _.indexOf(_.map(this.data.data, 'name'), name);
    if (this.isAvailable) {
      this.showError = true;
      return;
    }
    var temp = {
      name: name,
      state: 'create Shelf'
    }
    this.dialogRef.close(temp);
  }

  updateNewFolderName(ev, name) {
    if (ev.which == 13) {
      this.onYesClick(name);
    }
  }

  createWebEbe(name) {

    name = name.trim();
    var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable('Create_Book');
    if (isFeatureAvailable == 'false') {
      //  this.openSnackBar("This Feature is Not Enabled", '');
      this.LoginObservableService.openSubscribenowPopup();
      return;
    }


    this.bookNameErr = false;
    if (name == '') {
      this.bookNameErr = true;
      return;
    }

    var temp = {
      theme: this.bookThemes,
      state: 'createWebEBE',
      bookName: name,
      type: "book"
    }
    this.dialogRef.close(temp);
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      panelClass: ['snack-bar-color'],
      duration: 2000,
    });
  }

  onEnterAddEBEbook(ev) {
    if (ev.which == 13) {
      this.createWebEbe(this.ebeBookTitle);
    }
  }
  createAlbum(name) {
    name = name.trim();
    if (name == '' || name == undefined) {
      this.bookNameErr = true;
      return;
    }
    this.bookNameErr = false;
    let tempObj = {
      name: name,
      // imageUrl : this.url,
      // imageDetails:this.imageDetails,
      state: 'createAlbum'
    }
    this.dialogRef.close(tempObj);
  }

  selectedTemplateView(ev) {
    this.selectedTemplateViewInd = ev.index;
    if (this.selectedTemplateViewInd == 1) {
      // myTemplatesList
      var myCompThis = parent.window.document['mycompthis'];
      this.myTemplatesList = myCompThis.cteatedMytemplates;
    }
  }

  selectCreatingBookType(ev) {
    this.selectedBookTypeInd = ev.index;
  }

  updateSelectedTheme(ind, id) {
    this.selectedThemeInd = ind;
    this.bookThemes = this.bookTemplateDetails[id]
  }
  cancelSelectedTheme(ind, id) {
    this.selectedThemeInd = undefined;
    this.bookThemes = undefined;
  }

  readURL(fileInput) {
    this.imageDetails = fileInput;
    if (fileInput.target.files && fileInput.target.files[0]) {
      const reader = new FileReader();

      reader.onload = ((e) => {
        this.url = e.target['result'];
      });

      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  selectImages(ev) {
    this.selectEBEImg.nativeElement.click();
  }



  // my theme functionality


  addingMyTemplateImgs(state) {
    this.myTemplateImgState = state;

    if (state == 'cover') {
      this.myTemplateCoverSelectedType = 'Image';
    }
    else if (state == 'page') {
      this.myTemplatePageSelectedType = 'Image';
    }
    else if (state == 'back') {
      this.myTemplateBackSelectedType = 'Image';
    }

    this.myTemplateImgInput.nativeElement.click();
  }

  addingMyTemplateTemplates(state) {
    this.myTemplateImgState = state;

    if (state == 'cover') {
      this.myTemplateCoverSelectedType = 'Template';
    }
    else if (state == 'page') {
      this.myTemplatePageSelectedType = 'Template';
    }
    else if (state == 'back') {
      this.myTemplateBackSelectedType = 'Template';
    }

    this.templateAsEnrichmentObj.showPopup = true;
  }

  openSelectionOptions(state) {
    this.myTemplateImgState = state;
    if (state == 'cover') {
      if (this.myTemplateCoverSelectedType == 'Image') {
        this.myTemplateImgInput.nativeElement.click();
      }
      else if (this.myTemplateCoverSelectedType == 'Template') {
        this.templateAsEnrichmentObj.showPopup = true;
      }
    }
    else if (state == 'page') {
      if (this.myTemplatePageSelectedType == 'Image') {
        this.myTemplateImgInput.nativeElement.click();
      }
      else if (this.myTemplatePageSelectedType == 'Template') {
        this.templateAsEnrichmentObj.showPopup = true;
      }
    }
    else if (state == 'back') {
      if (this.myTemplateBackSelectedType == 'Image') {
        this.myTemplateImgInput.nativeElement.click();
      }
      else if (this.myTemplateBackSelectedType == 'Template') {
        this.templateAsEnrichmentObj.showPopup = true;
      }
    }
  }

  myTemplateImageChange(fileInput) {


    if (fileInput.target.files && fileInput.target.files[0]) {
      const reader = new FileReader();

      reader.onload = ((e) => {

        if (this.myTemplateImgState == 'cover') {
          this.myTempCoverUrl = e.target['result'];
        } else if (this.myTemplateImgState == 'page') {
          this.myTempPageUrl = e.target['result'];
        } else {
          this.myTempBackUrl = e.target['result'];
        }

      });
      reader.readAsDataURL(fileInput.target.files[0]);
      document.getElementsByClassName('showBookInfoloader')[0].classList.add('hideApploader');
      if (this.ElectronService.IS_ELECTRON) {

        this.ElectronService.insertFileintoMediaFolder(fileInput.target.files[0], this);
      }
      else {
        this.GoogleService.insertFileintofloder(fileInput.target.files[0], fileInput.target.files, localStorage.currentDriveMediaId, false, this);
      }

    }
    this.myTemplateImgInput.nativeElement.value = '';
  }

  imageAddedIntoDrive(file) {
    // let actualUrl = file.webContentLink.substring(0, file.webContentLink.indexOf("&export"));
    let actualUrl;
    if (this.ElectronService.IS_ELECTRON) {
      actualUrl = file;
    }
    else {
      actualUrl = file.thumbnailLink;
    }

    document.getElementsByClassName('showBookInfoloader')[0].classList.remove('hideApploader');
    if (this.myTemplateImgState == 'cover') {
      this.myTempCoverUrl = actualUrl;
    } else if (this.myTemplateImgState == 'page') {
      this.myTempPageUrl = actualUrl;
    } else {
      this.myTempBackUrl = actualUrl;
    }
  }

  createMyTempBook() {

    var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable('Create_Book');
    if (isFeatureAvailable == 'false') {
      //  this.openSnackBar("This Feature is Not Enabled", '');
      this.LoginObservableService.openSubscribenowPopup();
      return;
    }

    if (this.MyTempBookTitle == '') {
      this.myTemplateBookErr = true;
      return;
    } else {
      this.myTemplateBookErr = false;
      var themeContent = {
        cover: {
          "thumbUrl": this.myTempCoverUrl,
          "contentDocId": this.myTempCoverContentDocId
        },
        page: {
          "thumbUrl": this.myTempPageUrl,
          "contentDocId": this.myTempPageContentDocId
        },
        back: {
          "thumbUrl": this.myTempBackUrl,
          "contentDocId": this.myTempBackContentDocId
        }
      }
      var temp = {
        theme: themeContent,
        state: 'myTemplate',
        bookName: this.MyTempBookTitle,
        type: "book",
        templateId: this.mySelectedTemplateId
      }
      this.dialogRef.close(temp);

    }
  }

  updateSelectMyTemInd(ind) {
    this.selectedMyTemplateInd = ind;
    this.myTempCoverUrl = this.myTemplatesList[ind].cover.thumbUrl;
    this.myTempPageUrl = this.myTemplatesList[ind].page.thumbUrl;
    this.myTempBackUrl = this.myTemplatesList[ind].back.thumbUrl;
    this.mySelectedTemplateId = this.myTemplatesList[ind]._id;

  }

  cancelSelectedMyTemInd() {
    this.selectedMyTemplateInd = undefined;
    this.myTempCoverUrl = '';
    this.myTempPageUrl = '';
    this.myTempBackUrl = '';
    this.mySelectedTemplateId = '';
  }

  toggleStandardAndMyTemaplates() {

    this.mySelectedTemplateId = undefined;
    this.showSelectingMyTemplate = !this.showSelectingMyTemplate
  }

  onEnrichmentCallBack(message) {
    if (this.myTemplateImgState == 'cover') {
      this.myTempCoverUrl = "/assets/images/default-image.png";
      this.myTempCoverContentDocId = message.selectedThumbs[0].contentDocId;
    } else if (this.myTemplateImgState == 'page') {
      this.myTempPageUrl = "/assets/images/default-image.png";
      this.myTempPageContentDocId = message.selectedThumbs[0].contentDocId;
    } else {
      this.myTempBackUrl = "/assets/images/default-image.png";
      this.myTempBackContentDocId = message.selectedThumbs[0].contentDocId;
    }
  }

  onMyTemplateBack() {

    this.showSelectingMyTemplate = false;

    this.myTempCoverUrl = '';
    this.myTempPageUrl = '';
    this.myTempBackUrl = '';

    this.myTemplateCoverSelectedType = 'Image';
    this.myTemplatePageSelectedType = 'Image';
    this.myTemplateBackSelectedType = 'Image';

  }

}
//new folder template end







// WEBPACK FOOTER //
// ./src/app/shelf/mycontent/mycontent.component.ts